import { Canvg } from "canvg";

export function svgToPng(svgString) {
    try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext("2d");
        let v = Canvg.fromString(ctx, svgString);
        // Start drawing the SVG on the canvas
        v.start();
        // Convert the Canvas to an image
        let pngImageData = canvas.toDataURL("img/png");
        return pngImageData;
    } catch (error) {
        console.error(error);
        return '';
    }
}
